import React, { useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import "./paymentSorting.scss";
import {  DownDropArrow } from "../../../assets/images";

type AppProps = {
  setAllPaymentStatus: React.Dispatch<React.SetStateAction<number[]>>;
  allPaymentStatus: any;
  options: any
  history?:any;
};
const PaymentSorting = ({
  setAllPaymentStatus,
  allPaymentStatus,
  options,
  history
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  return (
    <div className="form-group mr-1">
      <ButtonDropdown
        color="#bfcbe1"
        isOpen={toggle}
        toggle={() => {
          setToggle(!toggle);
        }}
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            toggle
              ? {
                color: "#dd4433",
                border: "1px solid #dd4433",
                backgroundColor: "#fff6f5",
              }
              : { border: "1px solid#bfcbe1" }
          }
          outline
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span className={allPaymentStatus?.includes(10) || allPaymentStatus?.length === 0 ? "" : 'payment-count'}><span>{allPaymentStatus?.includes(10) || allPaymentStatus?.length === 0 ? "" : allPaymentStatus?.length}</span></span>
            <p style={{ margin: 0, color: "#262a44" }}>{allPaymentStatus?.length === 0 ? `All Status` : "Selected"} </p>
            <img src={DownDropArrow} alt="down_arrow" />
          </div>
        </DropdownToggle>

        <DropdownMenu right>
          <div
            className="p-3"
            style={{ minWidth: "200px", display: "inline-block" }}
          >
            {options?.map((el: any, i: number) => {
              return (
                <div
                  style={{ textAlign: "left", display: "flex" }}
                  className="p-2"
                >
                  <input
                    type="checkbox"
                    name="fordCheckBox"
                    style={{
                      width: "19px",
                      height: "19px",
                      backgroundColor: "red",
                    }}
                    className="checkbox"
                    checked={allPaymentStatus.includes(+el?.value)}
                    onChange={(data: any) => {
                      delete history?.location?.state?.allPaymentStatusRevenue
                      delete history?.location?.state?.allPaymentStatus
                      if (data?.target.checked && +el?.value == 10) {
                        let inputValue = [+el?.value, 0, 1, 2,3];
                        setAllPaymentStatus([...inputValue]);
                      } else if ((data?.target?.checked) && +el?.value !== 10) {
                        if (allPaymentStatus?.includes(10)) {
                          let findAllStatus = allPaymentStatus.indexOf(10);
                          let filterAllStatus = allPaymentStatus?.splice(
                            findAllStatus,
                            1
                          );
                          setAllPaymentStatus(filterAllStatus);
                        }
                        setAllPaymentStatus([...allPaymentStatus, +el?.value]);
                      }
                      else if (+el?.value != 10) {
                        if (allPaymentStatus?.includes(10)) {
                          let findAllStatus = allPaymentStatus?.indexOf(10);
                          allPaymentStatus?.splice(
                            findAllStatus,
                            1
                          );
                          let finalData = allPaymentStatus?.filter(
                            (value: number) => value != el?.value && value != 10
                          )
                          setAllPaymentStatus([...finalData,]);
                        }
                        else {

                          setAllPaymentStatus([
                            ...allPaymentStatus.filter(
                              (value: number) => value != el?.value
                            ),
                          ]);
                        }
                      }


                      else {

                        setAllPaymentStatus([
                          ...allPaymentStatus?.filter(
                            (value: number) => value != el?.value
                          ),
                        ]);
                      }
                    }}
                  />

                  <span className="ml-2" style={{ fontSize: "14px" }}>
                    {el?.label}
                  </span>
                </div>
              );
            })}
          </div>
        </DropdownMenu>
      </ButtonDropdown>
    </div>
  );
};

export default PaymentSorting;
